import EntityHelper from '../helpers/entity';

export default class Chip {
  constructor(data) {
    EntityHelper.validateData(data);
    const {
      id, color, title, type, textColor, icon,
    } = data;
    this.id = EntityHelper.setId(id);
    this.title = title;
    this.color = color;
    this.type = type;
    this.textColor = textColor;
    this.icon = icon;
  }
}
